import { render } from "./clockin.vue?vue&type=template&id=1fc4dd36"
import script from "./clockin.vue?vue&type=script&lang=js"
export * from "./clockin.vue?vue&type=script&lang=js"

import "./clockin.vue?vue&type=style&index=0&id=1fc4dd36&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__